module.exports = __webpack_public_path__ + "images/8ba6b71d1a33f27f5005ece03f7d739a.png";